import { DashboardWidgetDefinition } from 'src/app/shared/dashboard-grid';
import { DashboardFilters } from '../../dashboard.state';

/** The latest alerts in the dashboard's time range and priority, with links to each one. */
export const RECENT_ALERTS_WIDGET: DashboardWidgetDefinition<unknown, DashboardFilters> = {
  type: 'recent-alerts',
  title: 'Dashboard.RecentAlerts.Title',
  description: 'The latest alerts in the time range, newest first.',
  icon: 'notifications',
  loadComponent: () => import('./recent-alerts-widget.component').then((m) => m.RecentAlertsWidgetComponent),
  frame: 'edge',
  filtersFor: () => ['timeRange', 'priority'],
  size: { default: { w: 4, h: 6 }, min: { w: 3, h: 3 } },
};
